import type { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
import { formatMoney } from './money';

export interface PriceLabelProps {
  amount: number | null | undefined;
  currency?: string | null;
  /** İkincil satır (ör. yabancı para karşılığı). */
  secondary?: string;
  size?: 'sm' | 'md' | 'lg';
  emphasis?: boolean;
  strikethrough?: boolean;
  prefix?: ReactNode;
  suffix?: ReactNode;
  align?: 'left' | 'right';
  fallback?: string;
}

const VARIANT = { sm: 'body2', md: 'subtitle1', lg: 'h6' } as const;

/** Tutarlı fiyat gösterimi — booking sonuç kartları, özet satırları, ödeme adımı. */
export function PriceLabel({
  amount,
  currency,
  secondary,
  size = 'md',
  emphasis = false,
  strikethrough = false,
  prefix,
  suffix,
  align = 'left',
  fallback = 'Fiyat yok',
}: PriceLabelProps) {
  const text = amount != null ? formatMoney(amount, currency) : fallback;
  return (
    <Box sx={{ textAlign: align }}>
      <Typography
        variant={VARIANT[size]}
        component="span"
        sx={{
          fontWeight: emphasis ? 700 : 600,
          textDecoration: strikethrough ? 'line-through' : undefined,
          color: strikethrough ? 'text.disabled' : undefined,
        }}
      >
        {prefix}
        {text}
        {suffix}
      </Typography>
      {secondary && (
        <Typography variant="caption" color="text.secondary" component="div">
          {secondary}
        </Typography>
      )}
    </Box>
  );
}
